import { sequenceTableTemplate } from "../utils/squenceTableNo";

export const spColumns = (t) => {
  return [
    {
      body: sequenceTableTemplate,
      header: t("No"),
      style: { width: "3rem" },
    },
    {
      field: "name_en",
      header: t("NameEN"),
    },
    {
      field: "name_ar",
      header: t("NameAR"),
    },
    {
      field: "description",
      header: t("Description"),
    },
    {
      field: "department.name_en",
      header: t("Department"),
    },
    {
      field: "number_of_followup",
      header: t("No Of Follow Ups"),
    },
    {
      field: "intervel",
      header: t("Intervel"),
    },
    {
      field: "in_patient",
      header: t("In Patient"),
    },
    {
      field: "is_active",
      header: t("Active"),
    },
  ];
};

export const RCMSpecialitiesData = [
  {
    id: 1,
    code: "01.00",
    display: "Anesthesiology Specialty ",
  },
  {
    id: 2,
    code: "01.01",
    display: "Ambulatory Anesthesia",
  },
  {
    id: 3,
    code: "01.02",
    display: "Anesthesia Cardiology",
  },
  {
    id: 4,
    code: "01.03",
    display: "Neuro-Anesthesia",
  },
  {
    id: 5,
    code: "01.04",
    display: "Obstetrics Anesthesia ",
  },
  {
    id: 6,
    code: "01.05",
    display: "Pediatrics Anesthesia",
  },
  {
    id: 7,
    code: "01.06",
    display: "Pediatrics Cardiac Anesthesia ",
  },
  {
    id: 8,
    code: "01.07",
    display: "Regional Anesthesia",
  },
  {
    id: 9,
    code: "01.08",
    display: "Vascular / Thoracic Anesthesia",
  },
  {
    id: 10,
    code: "02.00",
    display: "Community Medicine Specialty",
  },
  {
    id: 11,
    code: "02.01",
    display: "Community Health",
  },
  {
    id: 12,
    code: "03.00",
    display: "Dermatology Specialty",
  },
  {
    id: 13,
    code: "03.01",
    display: "Dermatology Surgery ",
  },
  {
    id: 14,
    code: "03.02",
    display: "Hair Implant Dermatology ",
  },
  {
    id: 15,
    code: "03.03",
    display: "Pediatrics Dermatology ",
  },
  {
    id: 16,
    code: "04.00",
    display: "Emergency Medicine Specialty ",
  },
  {
    id: 17,
    code: "04.01",
    display: "Adult Emergency Medicine ",
  },
  {
    id: 18,
    code: "04.02",
    display: "Pediatrics Emergency Medicine ",
  },
  {
    id: 19,
    code: "05.00",
    display: "Ear, Nose and Throat Specialty ",
  },
  {
    id: 20,
    code: "05.01",
    display: "Adult ENT",
  },
  {
    id: 21,
    code: "05.02",
    display: "Laryngology",
  },
  {
    id: 22,
    code: "05.03",
    display: "Neuro - Otology and Otology ",
  },
  {
    id: 23,
    code: "05.04",
    display: "Nose, Ear Surgery ",
  },
  {
    id: 24,
    code: "05.05",
    display: "Oral and Maxillofacial Surgery ",
  },
  {
    id: 25,
    code: "05.06",
    display: "Otolaryngology",
  },
  {
    id: 26,
    code: "05.07",
    display: "Pediatrics ENT ",
  },
  {
    id: 27,
    code: "05.08",
    display: "Pediatrics Otolaryngology",
  },
  {
    id: 28,
    code: "05.09",
    display: "Rhinology ",
  },
  {
    id: 29,
    code: "05.10",
    display: "Audiology ",
  },
  {
    id: 30,
    code: "06.00",
    display: "Family Medicine Specialty ",
  },
  {
    id: 31,
    code: "06.01",
    display: "Family Medicine ",
  },
  {
    id: 32,
    code: "06.02",
    display: "Primary Care / Ophthalmology ",
  },
  {
    id: 33,
    code: "06.03",
    display: "Primary Care / Pulmonary ",
  },
  {
    id: 34,
    code: "06.04",
    display: "Primary Care Preventive Pediatrics",
  },
  {
    id: 35,
    code: "06.05",
    display: "Primary Health Care ",
  },
  {
    id: 36,
    code: "07.00",
    display: "Forensic Medicine Specialty ",
  },
  {
    id: 37,
    code: "08.00",
    display: "Internal Medicine Specialty ",
  },
  {
    id: 38,
    code: "08.01",
    display: "Adolescent Medicine ",
  },
  {
    id: 39,
    code: "08.02",
    display: "Cardiology ",
  },
  {
    id: 40,
    code: "08.03",
    display: "Diabetics Medicine",
  },
  {
    id: 41,
    code: "08.04",
    display: "Endocrinology ",
  },
  {
    id: 42,
    code: "08.05",
    display: "Gastrology/Gastroenterology",
  },
  {
    id: 43,
    code: "08.06",
    display: "Geriatrics ",
  },
  {
    id: 44,
    code: "08.07",
    display: "Hematology ",
  },
  {
    id: 45,
    code: "08.08",
    display: "Infectious Diseases ",
  },
  {
    id: 46,
    code: "08.09",
    display: "Nephrology",
  },
  {
    id: 47,
    code: "08.10",
    display: "Nuclear Medicine",
  },
  {
    id: 48,
    code: "08.11",
    display: "Oncology ",
  },
  {
    id: 49,
    code: "08.12",
    display: "Palliative Medicine ",
  },
  {
    id: 50,
    code: "08.13",
    display: "Pulmonology/Chest Medicine ",
  },
  {
    id: 51,
    code: "08.14",
    display: "Rheumatology ",
  },
  {
    id: 52,
    code: "08.15",
    display: "Sleep Medicine ",
  },
  {
    id: 53,
    code: "08.16",
    display: "Sport Medicine",
  },
  {
    id: 54,
    code: "08.17",
    display: "Hepatology ",
  },
  {
    id: 55,
    code: "08.18",
    display: "Neurology ",
  },
  {
    id: 56,
    code: "08.19",
    display: "Radiation Oncology ",
  },
  {
    id: 57,
    code: "08.20",
    display: "Diabetes Foot Care ",
  },
  {
    id: 58,
    code: "08.21",
    display: "Head & Neck Oncology",
  },
  {
    id: 59,
    code: "08.22",
    display: "Hematology - Stem Cell",
  },
  {
    id: 60,
    code: "08.23",
    display: "Congenital Heart Disease ",
  },
  {
    id: 61,
    code: "08.24",
    display: "Bariatric Medicine ",
  },
  {
    id: 62,
    code: "08.25",
    display: "Cardiothoracic",
  },
  {
    id: 63,
    code: "08.26",
    display: "General Medicine ",
  },
  {
    id: 64,
    code: "09.00",
    display: "Microbiology Specialty ",
  },
  {
    id: 65,
    code: "10.00",
    display: "Obstetrics and Gynecology Specialty ",
  },
  {
    id: 66,
    code: "10.01",
    display: "Gynecology Oncology ",
  },
  {
    id: 67,
    code: "10.02",
    display: "Infertility ",
  },
  {
    id: 68,
    code: "10.03",
    display: "IVF",
  },
  {
    id: 69,
    code: "10.04",
    display: "Perinatology ",
  },
  {
    id: 70,
    code: "10.05",
    display: "Urogynecology ",
  },
  {
    id: 71,
    code: "10.06",
    display: "Obstetrics ",
  },
  {
    id: 72,
    code: "10.07",
    display: "Reproductive Endocrinology & Infertility ",
  },
  {
    id: 73,
    code: "10.08",
    display: "Gynecology ",
  },
  {
    id: 74,
    code: "10.09",
    display: "Maternal Fetal Medicine ",
  },
  {
    id: 75,
    code: "11.00",
    display: "Ophthalmology Specialty ",
  },
  {
    id: 76,
    code: "11.01",
    display: "Comprehensive Ophthalmology ",
  },
  {
    id: 77,
    code: "11.02",
    display: "Diseases & Surgery of the Retina ",
  },
  {
    id: 78,
    code: "11.03",
    display: "Glaucoma ",
  },
  {
    id: 79,
    code: "11.04",
    display: "Neuro - Ophthalmology ",
  },
  {
    id: 80,
    code: "11.05",
    display: "Ocular Oncology ",
  },
  {
    id: 81,
    code: "11.06",
    display: "Oculoplastic ",
  },
  {
    id: 82,
    code: "11.07",
    display: "Ophthalmology ",
  },
  {
    id: 83,
    code: "11.08",
    display: "Pediatrics Ophthalmology & Strabismus ",
  },
  {
    id: 84,
    code: "11.09",
    display: "Primary Care / Ophthalmology ",
  },
  {
    id: 85,
    code: "11.10",
    display: "Uveitis / Medical Retina ",
  },
  {
    id: 86,
    code: "11.11",
    display: "Optometric ",
  },
  {
    id: 87,
    code: "11.12",
    display: "Anterior Segment ",
  },
  {
    id: 88,
    code: "11.13",
    display: "Anaplastology ",
  },
  {
    id: 89,
    code: "11.14",
    display: "Macular Dystrophy ",
  },
  {
    id: 90,
    code: "11.15",
    display: "Abyplopia ",
  },
  {
    id: 91,
    code: "11.16",
    display: "Ophthalmic Photography ",
  },
  {
    id: 92,
    code: "12.00",
    display: "Orthopedic Specialty ",
  },
  {
    id: 93,
    code: "12.01",
    display: "Oncology Orthopedic ",
  },
  {
    id: 94,
    code: "12.02",
    display: "Orthopedic Surgery ",
  },
  {
    id: 95,
    code: "12.03",
    display: "Pediatrics Orthopedic ",
  },
  {
    id: 96,
    code: "12.04",
    display: "Upper Limp Orthopedic",
  },
  {
    id: 97,
    code: "13.00",
    display: "Pathology Specialty ",
  },
  {
    id: 98,
    code: "13.01",
    display: "Bone & Soft Tissue Pathology ",
  },
  {
    id: 99,
    code: "13.02",
    display: "Dermatopathology ",
  },
  {
    id: 100,
    code: "13.03",
    display: "Gast. & Hepat Pathology",
  },
  {
    id: 101,
    code: "13.04",
    display: "Histopathology ",
  },
  {
    id: 102,
    code: "13.05",
    display: "Lymphoma Pathology",
  },
  {
    id: 103,
    code: "13.06",
    display: "Pathology Dermatology ",
  },
  {
    id: 104,
    code: "13.07",
    display: "Renal Pathology",
  },
  {
    id: 105,
    code: "14.00",
    display: "Pediatric Specialty",
  },
  {
    id: 106,
    code: "14.01",
    display: "Fetal Medicine ",
  },
  {
    id: 107,
    code: "14.02",
    display: "Neonatal Intensive Care (NICU)",
  },
  {
    id: 108,
    code: "14.03",
    display: "Pediatrics Imaging ",
  },
  {
    id: 109,
    code: "14.04",
    display: "Pediatrics Endocrinology ",
  },
  {
    id: 110,
    code: "14.05",
    display: "Pediatrics Gastroenterology ",
  },
  {
    id: 111,
    code: "14.06",
    display: "Pediatrics Genetics ",
  },
  {
    id: 112,
    code: "14.07",
    display: "Pediatrics Rheumatology",
  },
  {
    id: 113,
    code: "14.08",
    display: "Pediatrics Sleep Medicine ",
  },
  {
    id: 114,
    code: "14.09",
    display: "Pediatrics Orthopedic",
  },
  {
    id: 115,
    code: "14.10",
    display: "Pediatrics Hematology ",
  },
  {
    id: 116,
    code: "14.11",
    display: "Pediatrics Infectious Diseases",
  },
  {
    id: 117,
    code: "14.12",
    display: "Pediatrics Intensive Care ",
  },
  {
    id: 118,
    code: "14.13",
    display: "Pediatrics Nephrology",
  },
  {
    id: 119,
    code: "14.14",
    display: "Pediatrics Pulmonary Diseases ",
  },
  {
    id: 120,
    code: "14.15",
    display: "Primary Care Preventive Pediatrics ",
  },
  {
    id: 121,
    code: "14.16",
    display: "Pediatric Neurology",
  },
  {
    id: 122,
    code: "14.17",
    display: "Fetal Cardiology",
  },
  {
    id: 123,
    code: "14.18",
    display: "Neonatology ",
  },
  {
    id: 124,
    code: "14.19",
    display: "Pediatric Allergy ",
  },
  {
    id: 125,
    code: "14.20",
    display: "Pediatric Cardiology",
  },
  {
    id: 126,
    code: "15.00",
    display: "Pediatrics Surgery Specialty",
  },
  {
    id: 127,
    code: "15.01",
    display: "Pediatrics Cardiology ",
  },
  {
    id: 128,
    code: "15.02",
    display: "Pediatrics Neurosurgery ",
  },
  {
    id: 129,
    code: "15.03",
    display: "Pediatrics Oncology ",
  },
  {
    id: 130,
    code: "15.04",
    display: "Pediatrics Plastic Surgery ",
  },
  {
    id: 131,
    code: "15.05",
    display: "Pediatrics General Surgery ",
  },
  {
    id: 132,
    code: "15.06",
    display: "Pediatrics Hematology/Oncology ",
  },
  {
    id: 133,
    code: "16.00",
    display: "Physical Medicine & Rehabilitation Specialty ",
  },
  {
    id: 134,
    code: "16.01",
    display: "Physical Medicine & Rehabilitation ",
  },
  {
    id: 135,
    code: "16.02",
    display: "Occupational Medicine",
  },
  {
    id: 136,
    code: "17.00",
    display: "Psychiatry Specialty ",
  },
  {
    id: 137,
    code: "17.01",
    display: "Addiction Medicine ",
  },
  {
    id: 138,
    code: "17.02",
    display: "Child / Adolescent Psychiatry ",
  },
  {
    id: 139,
    code: "17.03",
    display: "Consultation - Liaison Psychiatry ",
  },
  {
    id: 140,
    code: "17.04",
    display: "Forensic Psychiatry ",
  },
  {
    id: 141,
    code: "17.05",
    display: "Geriatric Psychiatry ",
  },
  {
    id: 142,
    code: "17.06",
    display: "Mental Health ",
  },
  {
    id: 143,
    code: "17.07",
    display: "Mood Disorders Psychiatry ",
  },
  {
    id: 144,
    code: "17.08",
    display: "Psychiatry",
  },
  {
    id: 145,
    code: "17.09",
    display: "Rehabilitation Psychiatry ",
  },
  {
    id: 146,
    code: "17.10",
    display: "Schizophrenia",
  },
  {
    id: 147,
    code: "17.11",
    display: "Pediatric Behavior ",
  },
  {
    id: 148,
    code: "17.12",
    display: "Youth Stress Reduction ",
  },
  {
    id: 149,
    code: "18.00",
    display: "Radiology Specialty ",
  },
  {
    id: 150,
    code: "18.01",
    display: "Body Imaging ",
  },
  {
    id: 151,
    code: "18.02",
    display: "Breast Imaging ",
  },
  {
    id: 152,
    code: "18.03",
    display: "Cardiac Imaging ",
  },
  {
    id: 153,
    code: "18.04",
    display: "Chest Imaging ",
  },
  {
    id: 154,
    code: "18.05",
    display: "Diagnostic Neuroradiology",
  },
  {
    id: 155,
    code: "18.06",
    display: "Diagnostic Radiology",
  },
  {
    id: 156,
    code: "18.07",
    display: "Emergency Radiology ",
  },
  {
    id: 157,
    code: "18.08",
    display: "Interventional Neuroradiology ",
  },
  {
    id: 158,
    code: "18.09",
    display: "Interventional Radiology ",
  },
  {
    id: 159,
    code: "18.10",
    display: "Musculoskeletal Imaging ",
  },
  {
    id: 160,
    code: "18.11",
    display: "Pediatrics Imaging ",
  },
  {
    id: 161,
    code: "18.12",
    display: "Women's Imaging",
  },
  {
    id: 162,
    code: "19.00",
    display: "Surgery Specialty ",
  },
  {
    id: 163,
    code: "19.01",
    display: "Arthroplasty Surgery ",
  },
  {
    id: 164,
    code: "19.02",
    display: "Bariatric Surgery ",
  },
  {
    id: 165,
    code: "19.03",
    display: "Cosmetic Surgery ",
  },
  {
    id: 166,
    code: "19.04",
    display: "Craniofacial Surgery ",
  },
  {
    id: 167,
    code: "19.05",
    display: "Endocrinology Surgery ",
  },
  {
    id: 168,
    code: "19.06",
    display: "Facioplastic ",
  },
  {
    id: 169,
    code: "19.07",
    display: "Foot & Ankle Surgery ",
  },
  {
    id: 170,
    code: "19.08",
    display: "General Surgery ",
  },
  {
    id: 171,
    code: "19.09",
    display: "Hand Surgery ",
  },
  {
    id: 172,
    code: "19.10",
    display: "Hepatobiliary & Upper GI Surgery ",
  },
  {
    id: 173,
    code: "19.11",
    display: "Neurosurgery (Spinal Surgery) ",
  },
  {
    id: 174,
    code: "19.12",
    display: "Neurosurgery / Oncology ",
  },
  {
    id: 175,
    code: "19.13",
    display: "Neurosurgery Vascular ",
  },
  {
    id: 176,
    code: "19.14",
    display: "Plastic Surgery & Reconstruction ",
  },
  {
    id: 177,
    code: "19.15",
    display: "Skull Base Surgery ",
  },
  {
    id: 178,
    code: "19.16",
    display: "Spine Surgery",
  },
  {
    id: 179,
    code: "19.17",
    display: "Thoracic Surgery/Chest Surgery ",
  },
  {
    id: 180,
    code: "19.18",
    display: "Trauma Surgery",
  },
  {
    id: 181,
    code: "19.19",
    display: "Vascular Surgery ",
  },
  {
    id: 182,
    code: "19.20",
    display: "Colorectal Surgery ",
  },
  {
    id: 183,
    code: "19.21",
    display: "Transplant Surgery ",
  },
  {
    id: 184,
    code: "19.22",
    display: "Liver Transplant Surgery ",
  },
  {
    id: 185,
    code: "19.23",
    display: "Renal and Pancreas Transplant Surgery ",
  },
  {
    id: 186,
    code: "19.24",
    display: "Breast Surgery ",
  },
  {
    id: 187,
    code: "19.25",
    display: "Cardiothoracic Surgery ",
  },
  {
    id: 188,
    code: "19.26",
    display: "Burns",
  },
  {
    id: 189,
    code: "20.00",
    display: "Urology Specialty ",
  },
  {
    id: 190,
    code: "20.01",
    display: "Gynecology Urology ",
  },
  {
    id: 191,
    code: "20.02",
    display: "Laparoscopic Urology ",
  },
  {
    id: 192,
    code: "20.03",
    display: "Neuro - Urology ",
  },
  {
    id: 193,
    code: "20.04",
    display: "Oncology Urology ",
  },
  {
    id: 194,
    code: "20.05",
    display: "Pediatrics Urology ",
  },
  {
    id: 195,
    code: "20.06",
    display: "Reconstruction Urology",
  },
  {
    id: 196,
    code: "21.00",
    display: "Critical Care ",
  },
  {
    id: 197,
    code: "21.01",
    display: "Pediatric Critical Care (PICU) ",
  },
  {
    id: 198,
    code: "21.02",
    display: "Intensive Care (ICU) ",
  },
  {
    id: 199,
    code: "22.00",
    display: "Dental",
  },
  {
    id: 200,
    code: "22.01",
    display: "Pediatric Dental",
  },
  {
    id: 201,
    code: "22.02",
    display: "Prosthodontics ",
  },
  {
    id: 202,
    code: "22.03",
    display: "Endodontics ",
  },
  {
    id: 203,
    code: "22.04",
    display: "Periodontics ",
  },
  {
    id: 204,
    code: "22.05",
    display: "Orthodontics",
  },
  {
    id: 205,
    code: "22.06",
    display: "Dental Implants ",
  },
  {
    id: 206,
    code: "22.07",
    display: "Dental Hygiene ",
  },
  {
    id: 207,
    code: "22.08",
    display: "Special Needs Dentistry ",
  },
  {
    id: 208,
    code: "23.00",
    display: "Neurophysiology",
  },
  {
    id: 209,
    code: "24.00",
    display: "Speech/Speech Language Pathology ",
  },
  {
    id: 210,
    code: "25.00",
    display: "Infection Control ",
  },
];

export const ADM_DIS_SPECIALITY = RCMSpecialitiesData.map(item => ({
  label: `${item?.display || ''} (${item?.code || ''})`,
  value: item?.code
}));
